import React from "react";
import { Link, Redirect, Route, Switch, withRouter } from "react-router-dom";
import "./assets/sidebar.css";
import back from "../images/back.svg";
import bioLogo from "../images/bio_logo.png";
import $ from "jquery";
import PostType from './PostType';
import Dashboard from './Dashboard';
import { Container, Row } from 'react-bootstrap';


class Sidebar extends React.Component {
  constructor(props) {
        super(props);
        this.state = {
            login: this.props.location.state ? this.props.location.state.login : (localStorage.getItem("rememberMe") === "true"),
            detail_login: this.props.location.state ? this.props.location.state.detail_login : (localStorage.getItem("detail_login") ? JSON.parse(localStorage.getItem("detail_login")) : null),
            path: this.props.history.location.pathname,
            menuLogout: false,
            sidebarOpen: localStorage.getItem("bookmcu_sidebar_open") !== "false",
        }
        this.LogoutClick = this.LogoutClick.bind(this);
        this.HideLogout = this.HideLogout.bind(this);
        this.Logout = this.Logout.bind(this);
        this.active = this.active.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.isLevel1 = this.isLevel1.bind(this);
    }


  LogoutClick() {
        this.setState({
            menuLogout: !this.state.menuLogout,
        })
    }
    HideLogout() {
        this.setState({
            menuLogout: false,
            sidebarOpen: true,
        });
    }
    async Logout() {
        await localStorage.removeItem("rememberMe");
        await localStorage.removeItem("detail_login");
        await localStorage.removeItem("bookmcu_last_route");
        await this.setState({
            login: false,
        })
    }
    active() {
        this.setState((state, props) => {
            return {
                path: props.location.pathname,
            };
        }, () => console.log(this.state.path))
    }

    toggleSidebar() {
      this.setState(prev => ({ sidebarOpen: !prev.sidebarOpen }), () => {
        localStorage.setItem("bookmcu_sidebar_open", String(this.state.sidebarOpen));
      });
    }

    isLevel1() {
      const detail = this.state.detail_login || {};
      return String(detail.level).trim() === '1';
    }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      localStorage.setItem("bookmcu_last_route", this.props.location.pathname);
      if (this.state.path !== this.props.location.pathname) this.setState({ path: this.props.location.pathname });
    }
  }

  componentDidMount() {
    localStorage.setItem("bookmcu_last_route", this.props.location.pathname);
    $(window)
      .on("resize", function () {
        if ($(this).width() < 760) {
          $("tr td:first-child").click(function () {
            $(this).siblings().css({ display: "inline-block" });

            var $this = $(this);
            setTimeout(function () {
              $this.siblings().css("transform", "translateY(0)");
            }, 0);

            $("tr td:first-child")
              .not($(this))
              .siblings()
              .css({ display: "none", transform: "translateY(-9999px)" });
          });
        } else if ($(this).width() > 760) {
          //unbind click : name is not clickable when screen is > 700px
          $("tr td:first-child").unbind("click");
          //remove with jquery added styles
          $("tr td:first-child").siblings().css({ display: "", transform: "" });
        }
      })
      .resize();
    $(function () {
      $(".nav-item").on("click", function () {
        
        $(".nav-item").removeClass("active");
        $(this).addClass("active");
      });
    });

   

  }


  render() {
     if (this.state.login === false  || this.state.detail_login === null) {
            return (<Redirect to="" />)
        }
      const match = this.props.match.path;
      return (
       <>
          <div>
            {/* Vertical navbar */}
            <div className={"vertical-nav " + (this.state.sidebarOpen ? "sidebar-open" : "sidebar-closed")} id="sidebar">
              <div className="sidebar-brand">
                <img src={bioLogo} className="sidebar-brand-logo" alt="Bio Medika" />
              </div>
              <ul className="nav flex-column mb-0 sidebar-menu">
                <li className={"nav-item " + (this.state.path === '/admin' ? 'active' : '')}>
                <Link to={`${this.props.match.path}`} onClick={this.active} className="nav-link" type="button">
                    <span>
                        <i className="fa fa-home"></i> Dashboard
                    </span>
                </Link>
                </li>
                <li className={"nav-item " + (this.state.path === '/admin/pendaftaran' ? 'active' : '')}>
                <Link to={`${this.props.match.path}/pendaftaran`} onClick={this.active} className="nav-link" type="button">
                    <span>
                        <i className="fa fa-id-card-o"></i> Pendaftaran
                    </span>
                </Link>
                </li>
                
                { this.isLevel1() ? <li className={"nav-item " + (this.state.path === '/admin/kuota' ? 'active' : '')}>
                <Link to={`${this.props.match.path}/kuota`} onClick={this.active} className="nav-link" type="button">
                    <span>
                        <i className="fa fa-clock-o"></i> Kuota
                    </span>
                </Link>
                </li> : null }
                
                { this.isLevel1() ? 
                <li className={"nav-item " + (this.state.path === '/admin/reminder' ? 'active' : '')}>
                <Link to={`${this.props.match.path}/reminder`} onClick={this.active} className="nav-link" type="button">
                    <span>
                        <i className="fa fa-envelope-square"></i> Reminder
                    </span>
                </Link>
                </li>
                : null }
                
                <li className={"nav-item " + (this.state.path === '/admin/email-log' ? 'active' : '')}>
                <Link to={`${this.props.match.path}/email-log`} onClick={this.active} className="nav-link" type="button">
                    <span><i className="fa fa-envelope"></i> Email Log</span>
                </Link>
                </li>
                
                {this.isLevel1() ? 
                <li className={"nav-item " + (this.state.path === '/admin/email-template' ? 'active' : '')}>
                <Link to={`${this.props.match.path}/email-template`} onClick={this.active} className="nav-link" type="button">
                    <span><i className="fa fa-file-text-o"></i> Template Email</span>
                </Link>
                </li>
                 : null }

                <li className="nav-item" onClick={this.HideLogout}>
                   <Link to="#" onClick={this.Logout} className="nav-link" type="button">
                    <i className="fa fa-sign-out"></i> Log Out
                   </Link>
                </li>
                      
              </ul>
            </div>
            {/* Toggle sengaja diletakkan DI LUAR sidebar.
                Dengan begitu tombol show tetap terlihat ketika sidebar di-hide. */}
            <button
              id="sidebarCollapse"
              type="button"
              className={this.state.sidebarOpen ? "sidebar-toggle-open" : "sidebar-toggle-closed"}
              onClick={this.toggleSidebar}
              aria-label={this.state.sidebarOpen ? "Tutup menu" : "Buka menu"}
              aria-expanded={this.state.sidebarOpen}
            >
              <img src={back} alt="" aria-hidden="true" />
            </button>
            {/* End vertical navbar */}
          </div>
     
      <Container  style={{ padding: '20px'  }}>
        <Row style={{ width: '100%'  }}>
          
              <Switch>
                      <Route path={`${match}/:postType`}>
                          <PostType detail_login={this.state.detail_login} />
                      </Route>
                      <Route path={match}>
                          <Dashboard detail_login={this.state.detail_login} login={this.state.login} />
                      </Route>
              </Switch>
             
           </Row>
        </Container>
     
      </>
    );
  }
}
export default withRouter(Sidebar);
